export default function ImageBand() {
  return (
    <section className="bg-white py-8 md:py-12" data-testid="image-band">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-12 gap-4 md:gap-5">
          <div className="col-span-12 md:col-span-7 rounded-3xl overflow-hidden border border-black/[0.05]">
            <img
              src="https://images.unsplash.com/photo-1496181133206-80ce9b88a853?auto=format&fit=crop&w=1400&q=70"
              alt="MacBook med varm lyssetting"
              className="w-full h-72 md:h-96 object-cover"
              loading="lazy"
            />
          </div>
          <div className="col-span-6 md:col-span-5 rounded-3xl overflow-hidden border border-black/[0.05]">
            <img
              src="https://images.pexels.com/photos/1029757/pexels-photo-1029757.jpeg?auto=compress&cs=tinysrgb&w=900"
              alt="MacBook med varme toner"
              className="w-full h-72 md:h-96 object-cover"
              loading="lazy"
            />
          </div>
          <div className="col-span-6 md:hidden rounded-3xl overflow-hidden border border-black/[0.05]">
            <img
              src="https://images.unsplash.com/photo-1611186871348-b1ce696e52c9?auto=format&fit=crop&w=900&q=70"
              alt="MacBook på arbeidsbenk"
              className="w-full h-72 object-cover"
              loading="lazy"
            />
          </div>
        </div>

        <div className="mt-10 max-w-2xl">
          <p className="font-display text-2xl md:text-3xl text-[#1D1D1F] leading-snug tracking-tight">
            Håndverk møter teknologi.
            <span className="text-[#86868B]"> Vi behandler enheten din som vår egen.</span>
          </p>
        </div>
      </div>
    </section>
  );
}
